import {gql, QueryOptions} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {
  CanvasDefinitionFileStateQuery,
  CanvasDefinitionFileStateQueryVariables,
} from './__generated/CanvasDefinitionFileStateQuery';

export const CANVAS_DEFINITION_FILE_STATE_QUERY: DocumentNode = gql`
  query CanvasDefinitionFileStateQuery($canvasDefinitionId: StrictString!)
  @skipAudit
  @engComponent(name: CANVAS_CORE) {
    canvasDefinition(id: $canvasDefinitionId) {
      ...CanvasDefinitionFileStateGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('CanvasDefinitionFileState').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export type CanvasDefinitionFileStateGraphQL = ExtractByTypename<
  CanvasDefinitionFileStateQuery['canvasDefinition'],
  'CanvasDefinitionNode'
>;

export function getCanvasDefinitionFileStateQueryOptions(
  canvasDefinitionId: string
): QueryOptions<CanvasDefinitionFileStateQueryVariables> {
  return {
    query: CANVAS_DEFINITION_FILE_STATE_QUERY,
    variables: {canvasDefinitionId},
  };
}

export function canvasDefinitionFileStateDataToAttributes(data: CanvasDefinitionFileStateQuery): {
  name?: string;
} {
  const {canvasDefinition} = data;
  return isInaccessible(canvasDefinition) ? {} : {name: canvasDefinition.name};
}
